module.exports = __webpack_public_path__ + "img/select.bd06c34d.svg";